const cookieAcceptedName = "cookies_accepted";
const casinoCookieAcceptedName = "casino_cookies_accepted";
export {
  casinoCookieAcceptedName,
  cookieAcceptedName
};
